export default __webpack_public_path__ + "locales/uk-UA/Settings.json?hash=dcbc55ccdf33f9da2dfdf0acbcdb9716";